<template>
<div >
  <div class="form-group">
    <label for="store"><strong>MARKET</strong></label>
    
    <select :required="props.required" :disabled="props.disabled" @change="$emit('update',mpId,$event)"  class="form-control" v-model="mpId" >
        <option v-if="props.optionBase" value="0"> -- Seleziona un MARKET -- </option>    
        <option v-for="(item,index) in marketList" :value="item.MarketPlaceId" :key="index">{{item.MarketPlace}}</option>        
    </select>   
  </div>  
</div>


</template>
<script>
import api from '@/api'

import { mapGetters }    from 'vuex';

export default {
  props : ['props'] , 
  components: {},
  data() {
    return {

      mpId                : 0,
      marketList          : [],
      spinner             : false,
      
    };
  },
  watch: {
    props : {
        handler(value){
          if(value) {

            this.mpId = value.Id
            //console.log('Watch',value.Id)
            
          }
        },
        //immediate  : true,
        deep       : true,
      }
    
    
  },
  computed :{
    ...mapGetters(['company']),
   
  },
  mounted: function() {
  
  },
  created: function() {
     
      this.getData()
  },
  methods: 
  {
    async getData()
    {
      var sp    = {'sp'        : 'spCompanyMarketPlace'}
      var data  = {'companyId' : this.company.Id}
     
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.marketList =  res.data.recordsets[0]
            this.mpId = this.props.Id             
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

    },
    
    
  
    
    
  
}

}
</script>
<style scoped>

</style>